import { type PropsWithChildren, createContext, useContext, useState } from 'react';
export type AuthContextProps = {
  isLogin: boolean;
  setLogin: (login: boolean) => void;
};
const AuthContext = createContext<AuthContextProps | null>(null);
export const AuthProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [isLogin, setLogin] = useState<boolean>(false);
  return <AuthContext.Provider value={{
    isLogin,
    setLogin
  }}>
      {children}
    </AuthContext.Provider>;
};
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within a AuthProvider');
  }
  return context;
};